import {
  accountUserService,
  invitesService,
  buyerService,
  affiliateService,
  csvExportService,
  userSettingsService,
} from '@/angularBridgeCode/ringbaPortal.servicesModule';
import {
  SET_USERS,
  SET_ERROR,
  SET_PUBLISHERS,
  SET_BUYERS,
  SET_INVITES,
  SET_USER_SETTINGS,
  SET_USER_VISIBLE_COLUMNS,
  ADD_NEW_INVITE
} from './mutationTypes';
import {
  GET_USERS,
  GET_INVITES,
  GET_PUBLISHERS,
  GET_BUYERS,
  GET_USER_SETTINGS,
  GET_USER_VISIBLE_COLUMNS,
  INVITE_USER,
  DELETE_USER,
  DELETE_INVITE,
  EXPORT_CSV_FILE
} from './actionTypes';

import {
  SET_ACTION_STATUS_PENDING,
  SET_ACTION_STATUS_SUCCESS,
  SET_ACTION_STATUS_ERROR } from '@/store/helpers';

const actions = {
  async [GET_USERS]({ rootState, commit }) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_USERS });
    commit(SET_USERS, []);
    try {
      const response = await accountUserService.getAccountUsers(rootState.currentAccountId);
      commit(SET_USERS, response);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_USERS });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_USERS, error: e });
    }
  },
  async [GET_INVITES]({ rootState, commit }) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_INVITES });
    commit(SET_INVITES, []);
    try {
      var response = await invitesService.getInvites('allRoles', {
        accountId: rootState.currentAccountId
      });
      commit(SET_INVITES, response);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_INVITES });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_INVITES, error: e });
    }
  },
  async [GET_PUBLISHERS]({ rootState, commit }) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_PUBLISHERS });
    commit(SET_PUBLISHERS, {});
    try {
      var response = await affiliateService.getCachedAffiliates(rootState.currentAccountId);
      if(response && response.data && response.data.affiliates) {
        commit(SET_PUBLISHERS, _.keyBy(response.data.affiliates, 'id'));
      }
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_PUBLISHERS });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_PUBLISHERS, error: e });
    }
  },
  async [GET_BUYERS]({ rootState, commit }) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_BUYERS });
    commit(SET_BUYERS, {});
    try {
      var response = await buyerService.getCachedBuyers(rootState.currentAccountId);
      if(response && response.data && response.data.buyers) {
        commit(SET_BUYERS, _.keyBy(response.data.buyers, 'id'));
      }
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_BUYERS });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_BUYERS, error: e });
    }
  },
  async [GET_USER_VISIBLE_COLUMNS]({ commit }) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_USER_VISIBLE_COLUMNS });
    commit(SET_USER_VISIBLE_COLUMNS, []);
    try {
      var userVisibleColumns = _.map(_.filter(accountUserService.columnSettings, (col) => !col.hide), function(col) {
        return col.name;
      });
      commit(SET_USER_VISIBLE_COLUMNS, userVisibleColumns);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_USER_VISIBLE_COLUMNS });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_USER_VISIBLE_COLUMNS, error: e });
    }
  },
  async [INVITE_USER]({ rootState, commit }, user) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: INVITE_USER });
    try {
      const response = await invitesService.inviteUser('user',
        { accountId: rootState.currentAccountId },
        user);
      commit(ADD_NEW_INVITE, response);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: INVITE_USER });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: INVITE_USER, error: e });
    }
  },
  async [DELETE_USER]({ rootState, commit, dispatch }, userId) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: DELETE_USER });
    try {
      await accountUserService.deleteAccountUser(rootState.currentAccountId, userId);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: DELETE_USER });
      dispatch('getUsers');
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: DELETE_USER, error: e });
      commit(SET_ERROR, e.data.message);
    }
  },
  async [DELETE_INVITE]({ rootState, commit, dispatch }, inviteId) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: DELETE_INVITE });
    try {
      await invitesService.deleteInvite('user', {
        accountId: rootState.currentAccountId,
        inviteId: inviteId
      });
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: DELETE_INVITE });
      dispatch('getInvites');
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: DELETE_INVITE, error: e });
      commit(SET_ERROR, e.data.message);
    }
  },
  async [EXPORT_CSV_FILE]({ commit }, usersToExport) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: EXPORT_CSV_FILE });
    try {
      csvExportService.exportCSVFile(csvExportService.exportUsersHeaders, usersToExport, 'users');
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: EXPORT_CSV_FILE });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: EXPORT_CSV_FILE, error: e });
    }
  }
};

export default actions;